import { render } from "./AdvComponent.vue?vue&type=template&id=7b4e33d8"
import script from "./AdvComponent.vue?vue&type=script&lang=js"
export * from "./AdvComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__